import httpClient from './_httpClient';
import CONFIG from "../config/config";
import store from "../store";

const END_POINT = '/mail-credentials';
function endpoint(scopeId) {
  return "/scopes/" + scopeId + END_POINT;
}

const getMailCredentialsByScope = (scopeId) => httpClient.get(endpoint(scopeId));
const updateMailCredentials = (scopeId, mailCredentials) => httpClient.put(endpoint(scopeId), mailCredentials);
const testMailCredentials = (mailCredentials,scopeId) => httpClient.post(endpoint(scopeId)+ "/test", mailCredentials);
const testScopeMailCredentials = (scopeId) => httpClient.get(endpoint(scopeId) + "/test");
const updateSMTPTokens = (scopeId, redirectUrl) => {
  const tokenInLocalStorage = JSON.parse(localStorage.getItem(store.getters["auth/idTokenKey"]));
  return CONFIG.BASE_API_URL +
    "/scopes/mail-tokens?scope_id=" + scopeId +
    "&redirect=" + redirectUrl +
    "&token=" + tokenInLocalStorage.secret;
}

export {
  getMailCredentialsByScope,
  updateMailCredentials,
  testMailCredentials,
  testScopeMailCredentials,
  updateSMTPTokens
}
